import * as React from 'react';
import Flex from '../Flex';
import Text from '../Text';
import Checkbox from '../Checkbox/Checkbox';
import DataIterator, {DataIteratorRenderItemProps} from '../DataIterator';
import Card, {CardBody, CardHeader} from '../Card';
import {ExternalListingModelType} from '../../models/airbnbAuthModel';

export interface ListingsPickerProps {
  listings: ExternalListingModelType[];
  selection: ExternalListingModelType[];
  onSelectionChange: (selection: ExternalListingModelType[]) => void;
}

export default class ListingsPicker extends React.Component<ListingsPickerProps, {}> {
  public render() {
    return (
      <DataIterator
        items={this.props.listings}
        onSelectionChange={this._handleSelectionChange}
        renderItem={this._renderListing}
        contentsProps={{style: {height: '100%', overflow: 'auto'}}}
        contentsWrapperComponent={CardBody}
        selection={this.props.selection}
        rootComponent={Card}
        header={({handleSelectAllToggle, partiallySelected, allSelected}) => (
          <CardHeader>
            <Checkbox
              onChange={event => handleSelectAllToggle(event.target.checked)}
              indeterminate={partiallySelected}
              checked={allSelected}
            />
          </CardHeader>
        )}
      />
    );
  }

  private _renderListing = ({
    handleSelectToggle,
    selected,
    item: {name, address, previewImageUrl}
  }: DataIteratorRenderItemProps<ExternalListingModelType>) => {
    return (
      <Flex>
        <Checkbox
          onChange={event => {
            handleSelectToggle(event.target.checked);
          }}
          checked={selected}
        />
        <div style={{marginRight: 16, marginLeft: 16}}>
          {previewImageUrl ? <img src={previewImageUrl} style={{borderRadius: 3, width: 87}} /> : null}
        </div>
        <Flex direction="column" justify="center">
          <Text fontSize={18} style={{marginBottom: 8}}>
            {name}
          </Text>
          {address ? <Text>{address}</Text> : null}
        </Flex>
      </Flex>
    );
  };

  private _handleSelectionChange = (selection: ExternalListingModelType[]) => {
    this.props.onSelectionChange(selection);
  };
}



// WEBPACK FOOTER //
// ./src/components/ListingsPicker/ListingsPicker.tsx